







































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteHospitaisRemuneracaoStore from '../store/SuporteHospitaisRemuneracaoStore'

@Component
export default class ModalRemuneracaoAddGrupoRepasse extends Vue {
  $refs!: {
    formNovoGrupo: any,
  }

  loadSaveOrUpdateHospital: boolean = false

  get getSuporteHospitaisRemuneracaoStore() { return getModule(SuporteHospitaisRemuneracaoStore, this.$store) }

  get loadingSaveOrUpdateHospital() { return this.loadSaveOrUpdateHospital }
  set loadingSaveOrUpdateHospital(value: boolean) { this.loadSaveOrUpdateHospital = value }

  get showModal() { return this.getSuporteHospitaisRemuneracaoStore.modal.addOrEditGrupoRepasse }
  set showModal(value: boolean) { this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'addOrEditGrupoRepasse', value }) }

  formGrupo: any = {
    valid: true,
  }

  async saveOrUpdateHospital() {
    this.loadingSaveOrUpdateHospital = true

    if (this.$refs.formNovoGrupo.validate()) {
      const { mode } = this.getSuporteHospitaisRemuneracaoStore

      let response: any
      this.getSuporteHospitaisRemuneracaoStore.setNovoGrupoRepasse()
      response = await this.getSuporteHospitaisRemuneracaoStore.addOrUpdateGrupoRepasse()
      

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Grupo ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso!`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.getSuporteHospitaisRemuneracaoStore.getGrupoRepasse()
        this.showModal = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message || `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o grupo`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateHospital = false
  }

  @Watch('showModal')
  async onChangeshowModal(value: boolean) {
    if (!value) {
      this.getSuporteHospitaisRemuneracaoStore.clearNovoGrupoRepasse()
      this.getSuporteHospitaisRemuneracaoStore.clearItemGrupoRepasse()
      this.$refs.formNovoGrupo.resetValidation()
      this.$refs.formNovoGrupo.reset()
    }
  }
}
